import React from 'react';
import { useTranslation } from 'react-i18next';
import { REPAIR_LIMIT } from '../../view/sections';
import { SectionHead } from '../SectionHead';

// in place of the journey it is the journey; next to one it is the repair table
export const RepairTable = ({ repairs, allRepairs, onToggleAll, withJourney }) => {
    const { t } = useTranslation('reportPage');
    const rowStyle = { gridTemplateColumns: repairs.template, minWidth: repairs.minWidth };

    return (
        <div
            id={withJourney ? 'repairs' : 'timeline'}
            role="group"
            aria-labelledby="repairs-title"
            style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
        >
            <SectionHead
                as="h3"
                id="repairs-title"
                title={withJourney ? t('repairs.title') : t('journey.title')}
                sub={repairs.sub}
            />
            <div className="gt" role="table" aria-label={t('repairs.aria')}>
                <div className="gt-row gt-head" role="row" style={rowStyle}>
                    {repairs.head.map(column => (
                        <span className={`gt-cell${column.num ? ' num' : ''}`} role="columnheader" key={column.label}>
                            {column.label}
                        </span>
                    ))}
                </div>
                {repairs.rows.map((row, i) => (
                    <div className={`gt-row${row.hidden ? ' more' : ''}`} role="row" style={rowStyle} key={i}>
                        {row.cells.map((cell, j) => (
                            <span
                                className={`gt-cell${cell.num ? ' num' : ''}${cell.mono ? ' mono' : ''}${cell.src ? ' src' : ''}`}
                                role="cell"
                                key={j}
                            >
                                {cell.value}
                                {cell.sub && <span className="cell-sub">{cell.sub}</span>}
                            </span>
                        ))}
                    </div>
                ))}
            </div>
            {repairs.hasMore && (
                <button
                    type="button"
                    className="textlink noprint"
                    style={{ alignSelf: 'center' }}
                    onClick={onToggleAll}
                >
                    {allRepairs
                        ? t('repairs.showLatest', { count: REPAIR_LIMIT })
                        : t('repairs.showAll', { count: repairs.total })}
                </button>
            )}
        </div>
    );
};
